/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Cloud_Url_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Cloud URL" |
*
* @param {New_Project_Cloud_Url_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_cloud_url_placeholder = /** @type {((inputs?: New_Project_Cloud_Url_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Cloud_Url_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL du cloud")
	if (locale === "de") return /** @type {LocalizedString} */ ("Cloud-URL")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL del cloud")
	if (locale === "ru") return /** @type {LocalizedString} */ ("URL облака")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL de la nube")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("云网址")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クラウドURL")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लाउड यूआरएल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("URL da nuvem")
	return /** @type {LocalizedString} */ ("Cloud URL")
});